<div class="position-relative min-w-10em min-h-4em d-flex align-items-center">
    <span>{{count}}</span>
    <span class="preapproval-absolute-tag" *ngIf="preApprovalId > 0">
       {{ 'preApprovalTag' | translate }}
    </span>
</div>


